<template>
  <ul class="nav nav-pills nav-sidebar flex-column"
      data-widget="treeview"
      role="menu"
      data-accordion="false">
    <template v-for="navItem in userNavs">
      <li :key="navItem.id"
          class="nav-item"
          :class="{ 'has-treeview': (navItem.subPermissionGroups.length > 0 || navItem.permissions.filter(p => p.isSideBarItem == true).length > 0) }">
        <router-link @click.native="toggleIcons" v-if="!navItem.disabled" :to="(navItem.disabled ? '#' : (navItem.url || '#'))" class="nav-link d-flex align-items-center" :class="{ 'text-secondary': (navItem.isReadOnly) }">
          <i :class="navItem.iconClass || 'nav-icon fas fa-circle'"></i>
          <p class="text-sm px-2" :style="getStyle(navItem.name)">
            {{ navItem.name }}
          </p>
        </router-link>
        <template v-if="(navItem.subPermissionGroups.length > 0 || navItem.permissions.filter(p => p.isSideBarItem == true).length > 0) && !navItem.isReadOnly">
          <ul class="nav nav-treeview" style="display: none">
            <template v-for="pnavItem in navItem.permissions.filter(p => p.isSideBarItem == true)">
              <li :key="pnavItem.id" class="nav-item">
                <router-link v-if="!pnavItem.disabled" class="nav-link d-flex align-items-center" :to="(pnavItem.disabled ? '#' : (pnavItem.url || '#'))" :class="{ 'text-secondary': (pnavItem.disabled) }">
                  <i class="far fa-circle nav-icon"></i>
                  <p class="text-sm px-2" :style="getStyle(pnavItem.name)">
                    {{navItem.name !== 'Reports' ? TranslateText(pnavItem.name) : pnavItem.name}}
                  </p>
                </router-link>
              </li>
            </template>
            <template v-for="subNavItem in navItem.subPermissionGroups">
              <li :key="subNavItem.id"  class="nav-item" :class="{ 'has-treeview': (subNavItem.permissions.filter(p => p.isSideBarItem == true).length > 0) }">
                <router-link @click.native="toggleIcon" v-if="!subNavItem.disabled" :to="(subNavItem.disabled ? '#' : (subNavItem.url || '#'))"
                             class="nav-link d-flex align-items-center ml-1"
                             :class="{ 'text-secondary': (subNavItem.disabled) }">
                  <i v-if="!subNavItem.permissions.filter(p => p.isSideBarItem == true).length > 0" class="far fa-circle nav-icon"></i>
                  <i v-if="subNavItem.permissions.filter(p => p.isSideBarItem == true).length > 0"
                     class="fas fa-angle-right nav-icon"></i>
                  <p class="text-sm px-2" :style="getStyle(subNavItem.name) ">
                    {{navItem.name !== 'Reports' ? TranslateText(subNavItem.name) : subNavItem.name}}
                  </p>
                </router-link>
                <template v-if="subNavItem.permissions.filter(p => p.isSideBarItem == true).length > 0">
                  <ul class="nav nav-treeview" style="display: none">
                    <template v-for="spnavItem in subNavItem.permissions.filter(p => p.isSideBarItem == true)">
                      <li :key="spnavItem.id" class="nav-item">
                        <router-link v-if="!spnavItem.disabled" class="nav-link d-flex align-items-center ml-3" :to="(spnavItem.disabled ? '#' : (spnavItem.url || '#'))" :class="{ 'text-secondary': (spnavItem.disabled) }">
                          <i class="mdi mdi-angle-right nav-icon"></i>
                          <p class="text-sm px-2" :style="getStyle(spnavItem.name)">
                            {{navItem.name !== 'Reports' ? TranslateText(spnavItem.name) : spnavItem.name}} <i v-if="spnavItem.id === 86" class="fa fa-info-circle nav-icon" data-toggle="tooltip" data-placement="top" title="Applicable for Channel Manager Only"></i>
                          </p>
                        </router-link>
                      </li>
                    </template>
                  </ul>
                </template>
              </li>
            </template>
          </ul>
        </template>
      </li>
    </template>
  </ul>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: function () {
      return { 
        isInit: false
      };
    },
    computed: {
      ...mapGetters("permission", ["userNavs"]),
      ...mapGetters(["GetInitFn", 'TranslateText']),
    },
    mounted: function () {

      if (!this.GetInitFn()) {
        // console.log('init');
        $('[data-widget="treeview"]').Treeview('init');
        this.$store.commit('SetInit', true);
      }
     

      // console.log("usernavigation");

      //$(document).ready(() => {
      //  $('[data-widget="treeview"]').Treeview('init');
      //});

    },
    methods: {
      getStyle: function (name) {

        const nameLength = name.length;
        if (nameLength > 23) {
          //return { 'width': 'unset', 'white-space': 'initial' };
          return '';
        } else {
          return '';
        }

      },
      toggleIcon($event) {
        const icon = $event.currentTarget.querySelector('i.fas');
        if (!icon) return;

        if (icon.classList.contains('fa-angle-right')) {
          icon.classList.remove('fa-angle-right');
          icon.classList.add('fa-angle-down');
        } else if (icon.classList.contains('fa-angle-down')) {
          icon.classList.remove('fa-angle-down');
          icon.classList.add('fa-angle-right');
        }
      },
      toggleIcons($event) {
        const parentLi = $event.currentTarget.closest('li');
        if (!parentLi) return;

        const downIcons = parentLi.querySelectorAll('i.fa-angle-down');
        downIcons.forEach((icon) => {
          icon.classList.remove('fa-angle-down');
          icon.classList.add('fa-angle-right');
        });
      }
    },

  };
</script>


<style>
 

</style>



// WEBPACK FOOTER //
// src/components/UserNavigation.vue